module.exports = __webpack_public_path__ + "static/media/bck-dark.b24667f1.svg";